import * as F from '../common/features'
import * as P from '../common/permissions'

import { hasRole } from '../components/authorized'

export const hasPermissionToRetranscode = (partnerId, claims) =>
  hasRole(partnerId, F.CREATIVE_ASSETS, P.UPDATE, claims)
